import type { ReactNode } from "react"
import { Icon } from "./Icon"

export function Spinner({ label }: { label?: string }) {
  return (
    <div className="spinner" role="status" aria-live="polite">
      <span className="spinner-ring" aria-hidden="true" />
      {label ? <span className="spinner-label">{label}</span> : <span className="visually-hidden">Loading…</span>}
    </div>
  )
}

export function Skeleton({ lines = 3 }: { lines?: number }) {
  return (
    <div className="skeleton-card" aria-hidden="true">
      <div className="skeleton-row">
        <div className="skeleton skeleton-avatar" />
        <div className="skeleton-lines">
          <div className="skeleton skeleton-line short" />
          <div className="skeleton skeleton-line tiny" />
        </div>
      </div>
      {Array.from({ length: lines }).map((_, index) => (
        <div key={index} className={`skeleton skeleton-line ${index === lines - 1 ? "medium" : ""}`} />
      ))}
    </div>
  )
}

export interface EmptyStateProps {
  icon?: string
  title: string
  description?: ReactNode
  action?: ReactNode
}

export function EmptyState({ icon = "info", title, description, action }: EmptyStateProps) {
  return (
    <div className="empty-state">
      <div className="empty-state-icon">
        <Icon name={icon} size={22} />
      </div>
      <h2>{title}</h2>
      {description && <p>{description}</p>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  )
}

export function ErrorState({
  title = "Something went wrong",
  message,
  action,
}: {
  title?: string
  message?: string
  action?: ReactNode
}) {
  return (
    <div className="empty-state error-state" role="alert">
      <div className="empty-state-icon">
        <Icon name="alert" size={22} />
      </div>
      <h2>{title}</h2>
      {message && <p>{message}</p>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  )
}
